import { useState, useEffect } from 'react';

const SIZES = [
  { label: 'Small', value: 0.85 },
  { label: 'Normal', value: 1 },
  { label: 'Large', value: 1.12 },
  { label: 'X-Large', value: 1.25 },
];

export function useFontSize() {
  const [fontSize, setFontSizeState] = useState(() => {
    return parseFloat(localStorage.getItem('app_font_scale') || '1');
  });

  useEffect(() => {
    applyScale(fontSize);
  }, [fontSize]);

  const applyScale = (scale) => {
    const root = document.getElementById('root');
    if (root) {
      root.style.zoom = scale;
      // Fallback for Firefox which doesn't support zoom
      if (!CSS.supports('zoom', '1')) {
        root.style.transform = `scale(${scale})`;
        root.style.transformOrigin = 'top left';
        root.style.width = `${100 / scale}%`;
      }
    }
  };

  const setFontSize = (scale) => {
    localStorage.setItem('app_font_scale', String(scale));
    applyScale(scale);
    setFontSizeState(scale);
  };

  return { fontSize, setFontSize, SIZES };
}
